<template>
  <div class="">
    <div v-if="tracking">
      <div class="mt-3" v-if="title">
        <button @click="showDetails = !showDetails">
          {{ showDetails ? "-" : "+" }}
        </button>
        <h4 class="ml-3 d-inline-block">{{ title }}</h4>
      </div>
      <button
        v-if="allowEdit && !isEmptyString(templateUrl)"
        class="btn btn-primary"
        @click="generateExcelSheet"
      >
        Excel Datei generieren
      </button>
      <div
        v-if="showDetails"
        v-for="workingDay in tracking.workingDays.slice().reverse()"
        :key="workingDay.date"
      >
        <workingDayDetails
          :workingDay="workingDay"
          :allowEdit="allowEdit"
          @save="save"
        ></workingDayDetails>
      </div>
    </div>
  </div>
</template>

<script>
import { generateExcelSheet } from "@/common/timetrackingutils";
import { isEmptyString } from "@/common/utils";
import workingDayDetails from "@/components/timetracking/WorkingDayDetails.vue";

export default {
  name: "timeTrackingDetails",
  components: {
    workingDayDetails
  },
  data: function() {
    return {
      tracking: null,
      showDetails: false,
      isEmptyString
    };
  },
  beforeMount() {
    if (this.json != null) {
      this.tracking = JSON.parse(this.json);
      console.info("working days = " + this.tracking.workingDays.length);
    }

    this.showDetails = !this.hidden;
  },
  methods: {
    save() {
      this.$emit("save", this.tibId, JSON.stringify(this.tracking));
    },
    generateExcelSheet() {
      if (!this.isEmptyString(this.templateUrl)) {
        generateExcelSheet(
          this.templateUrl,
          this.year,
          this.title,
          this.tracking
        );
      } else {
        console.error("No template defined");
      }
    }
  },
  props: [
    "json",
    "allowEdit",
    "tibId",
    "hidden",
    "title",
    "year",
    "templateUrl"
  ]
};
</script>
